import { type InteractionSettings } from '@components/Presentation/types';
import { useState, useEffect } from 'react';
import Bar from './bar';

interface User {
  username: string;
}
interface RatingPollsChartProps {
  origin: 'EDIT_PRESENTATION' | 'LIVE_PRESENTATION' | 'RESULT'
  data: {
    contribution: {
      percentage: number;
      body: string;
      option_number?: number;
      totalUsers?: number;
      count?: number;
      users?: User[] ;
    }[];
    averageRating: string;
  };
  colors: any;
  settings: InteractionSettings;
}

const RatingPollsChart = ({ data, colors, settings, origin }: RatingPollsChartProps) => {
  const [contribution, setContribution] = useState(data?.contribution);

  useEffect(() => {
    if (!data?.contribution) return;

    const targetScale = parseInt(settings?.ratingPollScale || '5', 10);
    const currentLength = data.contribution.length;

    if (currentLength === targetScale) {
      setContribution(data.contribution);
    } else if (currentLength < targetScale) {
      const newContribution = [...data.contribution];

      for (let i = currentLength + 1; i <= targetScale; i++) {
        newContribution.push({
          option_number: i,
          percentage: 0,
          count: 0,
          body: ` ${i}`,
          users: []
        });
      }

      setContribution(newContribution);
    } else {
      const newContribution = data.contribution.slice(0, targetScale);
      setContribution(newContribution);
    }
  }, [settings?.ratingPollScale, data?.contribution]);

  const styles = {
    EDIT_PRESENTATION: {
      average: 'text-white text-2xl font-semibold mb-4',
      label: 'text-white text-xl font-semibold mt-2',
      gap: settings?.ratingPollScale === '5' ? 'gap-10' : 'gap-3'
    },
    LIVE_PRESENTATION: {
      average: 'text-white text-[32px] font-semibold mb-10',
      label: 'text-white  font-semibold mt-2 text-3xl',
      gap: settings?.ratingPollScale === '5' ? 'gap-10' : 'gap-3'
    },
    RESULT: {
      average: 'text-white text-xl font-semibold mb-4',
      label: 'text-white  font-semibold mt-2 text-xl',
      gap: settings?.ratingPollScale === '5' ? 'gap-10' : 'gap-3'
    }
  };
  const maxPercentage = Math.max(...contribution?.map(item => item.percentage) || [1]);
  return <div className='flex flex-col  justify-center items-center w-full h-full  ' >
    <p className={`text-white ${styles[origin as keyof typeof styles]?.average} `} style={{
      color: colors?.ratingPollsLabelColor || '#FFFFFF',
    }}>
    Average {data?.averageRating || 0.0}
    </p>
    <div className={` h-full flex   justify-center  w-full  ${styles[origin as keyof typeof styles]?.gap}`}>
      {contribution?.map((bar, index: number) => {
        const relativeValue = maxPercentage > 0 ? (bar.percentage / maxPercentage) * 100 : 0;
        return (

          <Bar origin={origin} index={index} value={bar?.percentage} relativeValue={relativeValue} label={bar.option_number?.toString() || ''}
            colors={colors} audienceContributionCount={bar?.totalUsers || 0}
            settings={settings} audienceProfile={bar?.users?.map((user) => user.username) || []} />

        );
      })}
    </div>

  </div>;
};

export default RatingPollsChart;
